import { MESSAGE_WIDTH, MESSAGE_WIDTH_AMOUNTS } from '@/constants/config';

// Shared geometry for Home and the Mac project welcome screen.
export function createNewChatWelcomeStyles(colors, isXS, messageWidth, keyboardHeight = 0, bottomInset = 0, isNative = false, pinInputToBottom = false) {
  return {
    container: {
      flex: 1,
      marginVertical: 0,
      marginHorizontal: 0,
      paddingVertical: isXS ? 0 : 20,
      paddingHorizontal: isXS ? 0 : 20,
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundColor: colors.solid_color_primary,
    },
    title: {
      fontSize: isXS ? 30 : 34,
      paddingHorizontal: isXS ? 20 : 0,
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
    },
    titleContainer: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: isXS ? 0 : 32,
    },
    modeSwitch: {
      alignSelf: 'center',
      width: '100%',
      alignItems: 'center',
      paddingTop: isXS ? 10 : 4,
      paddingBottom: isXS ? 8 : 12,
    },
    middleContainer: {
      width: '100%',
      maxWidth: isXS ? '100%' :
        messageWidth === MESSAGE_WIDTH.MEDIUM ? MESSAGE_WIDTH_AMOUNTS.MEDIUM : MESSAGE_WIDTH_AMOUNTS.NARROW,
      flex: 1,
      alignSelf: 'center',
      justifyContent: 'flex-start',
      ...(isNative ? { backgroundColor: colors.solid_color_primary } : {}),
    },
    centeredContent: {
      flex: 1,
      minHeight: 0,
      width: '100%',
      justifyContent: 'center',
    },
    inputContainer: {
      width: '100%',
      zIndex: 2,
      minWidth: 0,
      maxWidth: isXS ? '100%' : 860,
      marginHorizontal: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      backgroundColor: pinInputToBottom ? colors.solid_color_primary : 'transparent',
      paddingBottom: pinInputToBottom ? Math.max(keyboardHeight, bottomInset) : 0,
    },
    starterSuggestions: {
      width: '100%',
      paddingHorizontal: 8,
      marginBottom: 6,
    },
  };
}
